import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupbymatchid',
})
export class GroupByMatchId implements PipeTransform {
  transform(value, args: string[]): any {
    const groups = {};
    if (value != null) {
      if (value.length > 0) {
        value.forEach(function (o) {
          const group = o.EventId;
          const AwayTeam = o.AwayTeam;
          const AwayTeamCard = o.AwayTeamCard;
          const AwayTeamScore = o.AwayTeamScore;
          const Banko = o.Banko;
          const BetStopReason = o.BetStopReason;
          const BetStopReasonId = o.BetStopReasonId;
          const BetradarMatchId = o.BetradarMatchId;
          const CashOutValue = o.CashOutValue;
          const CustomerOddValue = o.CustomerOddValue;
          const EvenDate = o.EvenDate;
          const EventDateIso = o.EventDateIso;
          const EventId = o.EventId;
          const EventName = o.EventName;
          const HomeTeam = o.HomeTeam;
          const HomeTeamCard = o.HomeTeamCard;
          const HomeTeamScore = o.HomeTeamScore;
          const IsLive = o.IsLive;
          const MatchIsActive = o.MatchIsActive;
          const MatchStatus = o.MatchStatus;
          const MatchTime = o.MatchTime;
          const OddType = o.OddType;
          const Outcome = o.Outcome;
          const Reason = o.Reason;
          const SlipId = o.SlipId;
          const SpecialBetValue = o.SpecialBetValue;
          const State = o.State;

          groups[group] = groups[group]
            ? groups[group]
            : {
                EventId: group,
                AwayTeam: AwayTeam,
                AwayTeamCard: AwayTeamCard,
                AwayTeamScore: AwayTeamScore,
                Banko: Banko,
                BetStopReason: BetStopReason,
                BetStopReasonId: BetStopReasonId,
                BetradarMatchId: BetradarMatchId,
                CashOutValue: CashOutValue,
                CustomerOddValue: o.CustomerOddValue,
                EvenDate: o.EvenDate,
                EventDateIso: o.EventDateIso,
                EventName: o.EventName,
                HomeTeam: o.HomeTeam,
                HomeTeamCard: o.HomeTeamCard,
                HomeTeamScore: o.HomeTeamScore,
                IsLive: o.IsLive,
                MatchIsActive: o.MatchIsActive,
                MatchStatus: o.MatchStatus,
                MatchTime: o.MatchTime,
                OddType: o.OddType,
                Outcome: o.Outcome,
                Reason: o.Reason,
                SlipId: o.SlipId,
                SpecialBetValue: o.SpecialBetValue,
                State: o.State,
                oddInfos: [],
              };
          groups[group].oddInfos.push(o);
        });
      }
      return Object.keys(groups).map(function (key) {
        return groups[key];
      });
    }
  }
}
